import { styled } from '@mui/material';

export const TableHeaderWrapper = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));
